import { TournamentLeagues } from 'config/_enums';
import ITeamConfig from '../../model/Team/ITeamConfig';

export const getDefaultTeamConfiguration = (teamConfigurations: ITeamConfig[], leagueType: TournamentLeagues): ITeamConfig | undefined => {
    return teamConfigurations.find((teamConfig: ITeamConfig) => teamConfig.type === leagueType.toUpperCase());
};
